var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { useState, useEffect } from "react";
import { indexOf, difference } from "lodash";
export var useSteadyStates = function (initialSteadyStates) {
    if (initialSteadyStates === void 0) { initialSteadyStates = []; }
    var _a = __read(useState(initialSteadyStates), 2), steadyStates = _a[0], setSteadyStates = _a[1];
    useEffect(function () {
        setSteadyStates(initialSteadyStates);
    }, [initialSteadyStates]);
    var _b = __read(useState(createNewSteadyState()), 2), steadyStateBeingEdited = _b[0], setSteadyStateBeingEdited = _b[1];
    var _c = __read(useState(null), 2), steadyStateBeingEditedIndex = _c[0], setSteadyStateBeingEditedIndex = _c[1];
    var insertSteadyState = function (steadyState) {
        setSteadyStates(function (prevSteadyStates) {
            var i = steadyStateBeingEditedIndex !== null && steadyStateBeingEditedIndex !== void 0 ? steadyStateBeingEditedIndex : prevSteadyStates.length;
            return __spread(prevSteadyStates.slice(0, i), [
                steadyState
            ], prevSteadyStates.slice(i));
        });
    };
    var resetSteadyStateBeingEdited = function () {
        setSteadyStateBeingEdited(createNewSteadyState());
        setSteadyStateBeingEditedIndex(null);
    };
    var deleteSteadyState = function (steadyState) {
        setSteadyStates(function (prevSteadyStates) {
            return difference(prevSteadyStates, [steadyState]);
        });
    };
    var editSteadyState = function (steadyState) {
        setSteadyStateBeingEdited(steadyState);
        var i = indexOf(steadyStates, steadyState);
        setSteadyStateBeingEditedIndex(i);
        deleteSteadyState(steadyState);
    };
    var cancelSteadyState = function () {
        if (steadyStateBeingEditedIndex !== null) {
            insertSteadyState(steadyStateBeingEdited);
        }
        resetSteadyStateBeingEdited();
    };
    var saveSteadyState = function (steadyState) {
        insertSteadyState(steadyState);
        resetSteadyStateBeingEdited();
    };
    return {
        steadyStates: steadyStates,
        steadyStateBeingEdited: steadyStateBeingEdited,
        deleteSteadyState: deleteSteadyState,
        editSteadyState: editSteadyState,
        saveSteadyState: saveSteadyState,
        cancelSteadyState: cancelSteadyState
    };
};
var createNewSteadyState = function () { return ({
    parameters: {}
}); };
